import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TableRow from '../../components/Table/TableRow';
import TableHeader from '../../components/Table/TableHeader';
import LoadingImage from '../../assets/images/loader.svg';
import InventoryItemsCollection from '../../dao/collections/InventoryItemsCollection';
import dataModel from '../../models/DataModel';
import noInventoryIcon from '../../assets/images/bar-code-grey.svg';

import './Inventory.scss';
const inventoryItemDescriptor = {
  inventory_item: {
    inventory: {},
    user: {},
    tasks: {},
  },
};
class Inventory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inventoryItems: [],
      sortedType: '',
      updateInventory: true,
      loading: true,
    };
    this.handleActionCableUpdates = this.handleActionCableUpdates.bind(this);
    this.inventoryItemsCollection = InventoryItemsCollection.build(props.project.id, localStorage.loggedin_user_id, localStorage.current_company_id, inventoryItemDescriptor);
  }

  componentDidMount() {
    const { project } = this.props;
    if (project.id) {
      this.fetchData(true);
    }
    this.actionCableKey = Math.random();
    dataModel.actionCableConnector.register(this.actionCableKey, this.handleActionCableUpdates);
  }

  componentWillUnmount() {
    dataModel.actionCableConnector.unregister(this.actionCableKey);
  }

  componentDidUpdate(prevProps) {
    const nextProps = this.props;

    if (prevProps.project != nextProps.project && nextProps.project.id) {
      this.inventoryItemsCollection = InventoryItemsCollection.build(nextProps.project.id, localStorage.loggedin_user_id, localStorage.current_company_id, inventoryItemDescriptor);
      this.fetchData(true);
    }

    if (prevProps.updateInventory != nextProps.updateInventory && nextProps.updateInventory) {
      this.fetchData(true);
    }
  }

  handleActionCableUpdates(data) {
    if (data.type == 'updateTask' && data.project_id == this.props.project.id) {
      this.fetchData(true);
    }
  }

  fetchData(updateInventory = false) {
    if (updateInventory) {
      this.inventoryItemsCollection.fetchCurrent({ clear: true }).then(collectionData => {
        this.setState({ inventoryItems: collectionData.inventory_items || [], loading: false });
      });
    }
  }

  handleCreateInventoryRows() {
    let even = false;
    let rows;
    
    if (this.state.inventoryItems.length) {
      rows = this.state.inventoryItems.map(inventoryItem => {
        const clonedInventoryItem = Object.assign({}, inventoryItem);

        clonedInventoryItem.name = clonedInventoryItem.inventory.name;
        clonedInventoryItem.user = clonedInventoryItem.user ? `${clonedInventoryItem.user.last_name},${clonedInventoryItem.user.first_name}` : null;
        const tasksAttachedTo = clonedInventoryItem.tasks ? clonedInventoryItem.tasks.map(task => {
          return task ? task.name : '';
        }) : [];
        clonedInventoryItem.tasks = tasksAttachedTo;

        even = !even;
        return (
            <TableRow
              key={clonedInventoryItem.id}
              selectedItem={ clonedInventoryItem }
              even={ even }
              type={'inventory'}
            />
          );
      });
    } else {
      rows = (
        <div className='no-inventory-cont'>
          <img className='no-inventory-icon' src={noInventoryIcon} alt='There is no Inventory for this Project'/>
          <div className='no-inventory-text'>There is no Inventory for this Project.</div>
        </div>
      );
    }
    return rows;
  }

  createInventoryHeader() { 
    const sortDirectionClass  = this.state.sortAsc ? '' : 'down';
    let { accent } = this.props;
    
    let caretTypes = [
      { type: 'id', headerName: 'INVENTORY ID', first: true }, 
      { type: 'name', headerName: 'INVENTORY NAME' }, 
      { type: 'added_by', headerName: 'ADDED BY' },
      { type: 'created_at', headerName: 'ENTRY DATE' }, 
      { type: 'task', headerName: 'TASK ATTACHED TO' },
    ];

    return (
      <TableHeader 
        accent={ accent } 
        sortDirectionClass={ sortDirectionClass }
        handleSort={ this.handleSort }
        sortedType={ this.state.sortedType }
        caretTypes={ caretTypes } 
        reportType={'inventory'}
      />
    );
  }

  //search box commented out of render until later
  // <div className='inventory-search-box'>
    // <div className='search-icon'></div>
    // <input placeholder='Search Projects' />
  // </div>

  render() {
    let { height } = this.props;
    let style = {};
    if (height) {
      style.height = height;
    }
    
    let rowDisplay = this.state.loading ? 'tableContainer rowDisplay' : 'tableContainer';
    let rows = this.handleCreateInventoryRows();

    return (
      <div className="Inventory" id='inventoryDisplay' style={style}>
        <div className='inventory-header'>
          <h1>Inventory</h1>
        </div>

        { this.state.loading ? (
            <section className="top-section">
              <img className="loader" src={LoadingImage} alt="loading-icon" />
              <p>{'Loading Inventory...'}</p>
            </section>
          )
          : <div></div> 
        }

        <div className={ rowDisplay }>
          { this.createInventoryHeader() }
          <div className='inventory-rows-container'>
            { rows }
          </div>
        </div>

      </div>
    );
  }
}

export default Inventory;

Inventory.propTypes = {
  accent: PropTypes.string,
  project: PropTypes.object.isRequired,
  height: PropTypes.number.isRequired,
  actionCableUpdate: PropTypes.bool,
};




// WEBPACK FOOTER //
// ./src/components/Inventory/index.js